export const MY_ISUZU_APP_STORE_URLS = {
  IOS: 'https://apps.apple.com/us/app/my-isuzu/id1612415578',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.tis.myisuzu',
} as const;
